import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { getCategoryColor } from '../constants/categoryColors';
import { getArticleSnippet } from '../utils/articleHelpers';
import AdSlot from './AdSlot';

function TopNewsHero({ mainStory, latestUpdates }) {
  if (!mainStory) return null;

  const mainColor = getCategoryColor(mainStory.category);

  return (
    <section className="max-w-[1600px] mx-auto px-6 py-12">
      <div className="grid grid-cols-12 gap-6">
        <Link
          to={`/article/${mainStory.id}`}
          data-testid="top-news-main-story-link"
          className="col-span-12 lg:col-span-8 border border-[#E5E5E5] overflow-hidden group cursor-pointer bg-white block"
        >
          <div className="relative h-96 overflow-hidden">
            <img
              src={mainStory.image_url}
              alt={mainStory.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute top-4 left-4 flex gap-2">
              <span className="bg-[#FFB703] text-[#1A1A2E] px-3 py-1 text-xs font-bold tracking-[0.2em] uppercase shadow-md">
                ★ BREAKING
              </span>
              <span
                className="px-3 py-1 text-xs font-bold tracking-[0.2em] uppercase shadow-md"
                style={{ backgroundColor: mainColor.bg, color: mainColor.text }}
              >
                {mainColor.name}
              </span>
            </div>
          </div>
          <div className="p-6 bg-white">
            <div className="flex items-center gap-2 mb-3 text-xs tracking-[0.2em] uppercase font-bold text-[#8A8A8A]">
              <Clock size={14} />
              <span>{new Date(mainStory.published_at).toLocaleDateString()}</span>
              <span>•</span>
              <span style={{ color: mainColor.bg }}>{mainStory.category}</span>
            </div>
            <h2 className="text-3xl sm:text-4xl tracking-tight leading-none font-bold text-[#1A1A2E] mb-3 group-hover:text-[#E63946] transition-colors">
              {mainStory.title}
            </h2>
            <p className="text-base leading-relaxed text-[#525252]">
              {getArticleSnippet(mainStory.content, 200)}
            </p>
          </div>
        </Link>

        <div className="col-span-12 lg:col-span-4 border border-[#E5E5E5] bg-white">
          <div className="p-4 border-b-4" style={{ borderColor: '#E63946' }}>
            <h3 className="text-xl font-bold tracking-tight text-[#1A1A2E] flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[#E63946] animate-pulse"></span>
              LATEST UPDATES
            </h3>
          </div>
          <div data-testid="latest-updates-list">
            {latestUpdates && latestUpdates.map((article, idx) => {
              const c = getCategoryColor(article.category);
              return (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  data-testid={`latest-update-${idx}`}
                  className="block p-4 border-b border-[#E5E5E5] hover:bg-[#FFF8F0] transition-colors cursor-pointer"
                >
                  <div
                    className="inline-block text-xs tracking-[0.2em] uppercase font-bold mb-2 px-2 py-0.5"
                    style={{ backgroundColor: c.tint, color: c.bg }}
                  >
                    {article.category}
                  </div>
                  <h4 className="text-base sm:text-lg font-bold text-[#1A1A2E] leading-snug hover:text-[#E63946] transition-colors">
                    {article.title}
                  </h4>
                </Link>
              );
            })}
          </div>
          <div className="p-4">
            <AdSlot slot="sidebar" height={250} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default TopNewsHero;
